/**
 * ShotButton v0.3
 *
 * 画面下部のメインアクションボタン（オレンジ塗り、矩形）。
 * v0.2 までは「SHOT」固定だったが、通訳モードで START/STOP/RETRY も
 * このボタンを使うため、label を上書きできるようにした。
 *
 * 処理中は label を 'WAIT' に強制差し替え（画像系モード用、isProcessing=true で発動）。
 */

import styles from './ShotButton.module.css';

export interface ShotButtonProps {
  onClick: () => void;
  /** 処理中フラグ（true の間はボタンを押せなくする・ラベルが WAIT に） */
  isProcessing: boolean;
  disabled?: boolean;
  /** 表示ラベル（未指定時は SHOT） */
  label?: string;
}

export function ShotButton({ onClick, isProcessing, disabled = false, label = 'SHOT' }: ShotButtonProps) {
  return (
    <button
      type="button"
      className={styles.root}
      onClick={onClick}
      disabled={disabled || isProcessing}
      aria-label={label}
    >
      {isProcessing ? 'WAIT' : label}
    </button>
  );
}
